module.exports = "/static/assets/214ca2d22751f17cf368c5231de4936f.gif";